import { isEqual } from "lodash";
import { useLocation, matchPath } from "react-router-dom";

import rmEmptyFields from "utils/rm-empty-fields";
import { useDidUpdate, useNavigationHooks, useUrlHooks } from "..";
import { useDealQueriesSelect } from "store";
import { defaultDealsQueries } from "constants/deal";
import { Routes } from "constants/routes";
import { useMemo } from "react";
import { DealsQueries } from "store/types";

export function useDealsQueriesToUrl(): void {
  const queries = useDealQueriesSelect();
  const { setParams, removeParams } = useNavigationHooks();
  const { pathname } = useLocation();
  const { queryParams } = useUrlHooks();

  const dealsQueryParamsFromUrl = useMemo(() => queryParams.deals, [queryParams]);

  const clearedQueries: Partial<DealsQueries> = useMemo(() => rmEmptyFields(queries), [queries]);

  const isDefaultParameters = useMemo(() => {
    return isEqual(clearedQueries, rmEmptyFields(defaultDealsQueries));
  }, [clearedQueries]);

  useDidUpdate(() => {
    // Remove deals queries when outside My Deals page if they are in the URL
    if (dealsQueryParamsFromUrl && !matchPath(pathname, Routes.myDeals)) {
      return removeParams(["deals"]);
    }

    // Return query parameters to the URL if they are not default
    if (matchPath(pathname, Routes.myDeals) && !isDefaultParameters) {
      setParams({
        search: {
          deals: JSON.stringify({ ...clearedQueries })
        }
      });
    }
  }, [pathname]);

  // Listen to queries in the storage and set them in the URL
  useDidUpdate(() => {
    // Skip if no My Deals page
    if (!matchPath(pathname, Routes.myDeals)) {
      return;
    }

    // If queries are default remove them from the URL
    if (isDefaultParameters) {
      return removeParams(["deals"]);
    }

    // Set queries to the URL
    setParams({
      search: {
        deals: JSON.stringify({ ...clearedQueries })
      }
    });
  }, [clearedQueries]);
}
